/* @flow */
import {transformDataForReport} from 'nutshell-core/json-to-report-data';
import type {ActionsObservable} from 'redux-observable';
import {Observable} from 'rxjs';
import {switchMap, filter, map, catchError} from 'rxjs/operators';

import {updateReportChartData, failReportChartData} from './connected-forms-actions';
import type {ReportDataRequestedAction} from './types';
import {getReportPostParams, type ConnectedFormReportPostParams} from './utils';

export const requestConnectedFormsReportDataEpic = (action$: ActionsObservable<*>) =>
    action$.ofType('CONNECTED_FORMS_REPORT_DATA_REQUESTED').pipe(
        switchMap((action: ReportDataRequestedAction) => {
            const {reportParams, filters} = action.payload;
            const params = getReportPostParams(reportParams, filters);
            const requestStream = Observable.from(fetchData(params));
            const reportDataStream = requestStream.pipe(map(transformDataForReport));

            const reportChartDataStream = reportDataStream.pipe(
                map((data) => data.chartData),
                filter((chartData) => Boolean(chartData)),
                map((chartData) => updateReportChartData({chartData}))
            );

            return reportChartDataStream.pipe(
                catchError((err) => Observable.of(failReportChartData(err)))
            );
        })
    );

function fetchData(params: ConnectedFormReportPostParams) {
    return Promise.all([fetchConnectedFormReportData(params)]);
}

function fetchConnectedFormReportData(params: ConnectedFormReportPostParams): Promise<any> {
    const url = '/rest/forms/report';
    const ajaxParams = {
        url,
        dataType: 'json',
        data: params,
    };

    return ($.ajax(ajaxParams): any); // This is how we have to convince flow that the response is a ReportsResponse
}
